import styled from '@emotion/styled'
import React from 'react'
import { getComponentTheme, breakpointSwitch } from '../../../__styling'

export interface ElectionTitleProps {
    children?: React.ReactNode
}

export const ElectionTitle = ({ children }: ElectionTitleProps) => (
    <StyledElectionTitle>{children}</StyledElectionTitle>
)

// Container object, handles the background colours and the hover, & onClick!
export const StyledElectionTitle: React.FC = styled('h2')(({ theme }) => {
    const electionTheme = getComponentTheme(theme, 'electionTheme')

    return [
        {
            textAlign: 'right',
            margin: 0,
        },
        electionTheme.title &&
            breakpointSwitch(electionTheme.title, (styles) => styles),
    ]
})
